<template>
  <base-row
    v-bind="$props"
    :selectable="false"
  >
    <td>
      <Link
        :href="route('company.locations.edit', { location: item.id })"
        class="font-semibold text-blue-600 hover:text-blue-600"
      >
        {{ item.name }}
      </Link>
    </td>
    <td>
      {{ item.address.street_1 || '' }}
    </td>
    <td>
      {{ item.license_number }}
    </td>
    <td>
      {{ item.types.join(', ') }}
    </td>
    <td>
      {{ formatDate(item.created_at) }}
    </td>
    <td>
      {{ formatDate(item.updated_at) }}
    </td>
    <!--        <td class="text-right">-->
    <!--            <a href="#" @click.prevent="removeLocation(item)" class="text-red-600 rounded-md">-->
    <!--                Remove-->
    <!--            </a>-->
    <!--            <Popover>-->
    <!--                <PopoverButton class="btn btn-secondary-outline">-->
    <!--                    <DotsHorizontalIcon class="h-4 w-4" aria-hidden="true" />-->
    <!--                </PopoverButton>-->

    <!--                <PopoverPanel class="absolute z-50 right-6">-->
    <!--                    <div class="menu w-32 text-left">-->
    <!--                        <div class="py-1">-->
    <!--                            <Link :href="route('company.locations.edit', { location: item.id })" class="menu-item menu-link">-->
    <!--                                Edit Location-->
    <!--                            </Link>-->
    <!--                            <a href="#" @click.prevent="removeLocation(item)" class="menu-item menu-link hover:bg-blue-600 hover:text-gray-100 rounded-md">-->
    <!--                                Remove-->
    <!--                            </a>-->
    <!--                        </div>-->
    <!--                    </div>-->
    <!--                </PopoverPanel>-->
    <!--            </Popover>-->
    <!--        </td>-->
  </base-row>
</template>

<script>
import { Link } from '@inertiajs/vue3'
import TableRow from '@/Components/Table/TableRow'
import RowProps from '@/Components/Table/Mixins/RowProps'
import _date from '@/Filters/Date'
import _percent from '@/Filters/Percent'
import BasicBadge from '@/Components/Badges/BasicBadge.vue'
import dateFilters from '@/Mixins/dateFilters'
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import { DotsHorizontalIcon } from '@heroicons/vue/solid'

export default {
  components: {
    'base-row': TableRow,
    Link,
    BasicBadge,
    Popover,
    PopoverButton,
    PopoverPanel,
    DotsHorizontalIcon
  },

  mixins: [RowProps, dateFilters],

  props: {
    /**
     * A function that we can use to generate the URL to view a package. Returns a string that is a valid URL
     */
    showRoute: {
      type: Function,
      default: (item) => null
    }
  },

  computed: {
    /**
     * Returns the URL we can use to view a package
     */
    showIntegrationRoute() {
      return this.showRoute(this.item)
    },

    /**
     * Returns true if this package has a valid URL to view a package
     * @returns {boolean}
     */
    hasRoute() {
      return this.showIntegrationRoute !== null
    }
  },
  methods: {
    _date,
    _percent,
    removeLocation(location) {
      this.$emit('remove', location)
    }
  }
}
</script>
